cv.NotificationsView = Marionette.LayoutView.extend({
  template: cv.Templates['notifications/view'],

  events : {
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior
  }],

  validation: {
    notif_donation: [{
      required: true,
      msg: 'Required.'
    }],
    notif_team_donation: [{
      required: true,
      msg: 'Required.'
    }],
    notif_team_join: [{
      required: true,
      msg: 'Required.'
    }]
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    this.listenTo(this, 'form:saved', function(){
      vent.trigger('notif:success', 'Notifications have been saved.');
    }, this);

    console.log('NotificationsView initialized.');
  },

  onShow: function(){
  },

  onDestroy: function(){
  }
});
